import * as React from "react"
import { cn } from "@/lib/utils"

const Input = React.forwardRef(({ className, type, style, ...props }, ref) => {
  const mergedStyle = Object.assign({
    backgroundColor: 'var(--card)',
    border: '1px solid var(--border)',
    borderRadius: '0px',
    color: 'var(--foreground)',
    fontFamily: "'Inter', sans-serif",
  }, style);
  return (
    <input
      type={type}
      style={mergedStyle}
      className={cn(
        "flex h-12 w-full px-4 py-2 text-sm shadow-sm transition-all file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus:outline-none focus:border-primary focus:ring-1 focus:ring-[#00E676] focus:shadow-[0_0_15px_rgba(0,230,118,0.15)] disabled:cursor-not-allowed disabled:opacity-50",
        className
      )}
      ref={ref}
      {...props} />
  );
})
Input.displayName = "Input"

export { Input }
